import { batch } from 'react-redux';
import { AppThunkAction, RootState } from '../reducers/root-reducer';
import {
  fetchFormFieldsError,
  fetchFormFieldsRequest,
  fetchFormFieldsSuccess,
  setField,
  setReasons
} from '../reducers/form-fields/form-fields.reducer';
import { FetchedFieldsData, FormFieldsData } from '../../types/form.types';

const onError = <S = RootState>(errorMessage: string): AppThunkAction<S> => {
  return async (dispatch): Promise<void> => {
    dispatch(fetchFormFieldsError(errorMessage));
  };
};

const fetchFieldsAction = <S = RootState>(
  fetchFunction: () => Promise<FetchedFieldsData>
): AppThunkAction<S> => {
  return async (dispatch): Promise<void> => {
    // REQUEST STARTED
    dispatch(fetchFormFieldsRequest());

    try {
      const {
        case_reason,
        case_detailed_reason,
        ...fieldsData
      } = await fetchFunction();

      if (!fieldsData) {
        return await dispatch(onError<S>('Form fields data is null!'));
      }
      return batch(() => {
        // SUCCESS
        dispatch(setField(fieldsData as FormFieldsData));
        dispatch(setReasons({ case_reason, case_detailed_reason }));
        dispatch(fetchFormFieldsSuccess());
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      // FAILURE
      return await dispatch(onError<S>(err.toString()));
    }
  };
};

export default fetchFieldsAction;
